// extracted by mini-css-extract-plugin
export default {"prefix":"styles_prefix__JKldn"};